import instance from './http.service';

const PricesService = {
  getTokenPrices: async () => {
    return instance.get('/prices');
  },
};

export default PricesService;
